export function isNotNull<T>(value: null | T | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isError(error: unknown): error is Error {
  if (!(error instanceof Error)) {
    return false;
  }

  return true;
}

/**
 * Checks if a value is an array of strings.
 * @param value - The value to check.
 * @returns True if the value is an array of strings, false otherwise.
 */
export function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
}
